import './person-select-step.scss';
import { IconBtn, UiSelect } from '@ru-digital-assets/ui-component';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import { useState, useCallback } from 'react';
import UserIcon from 'assets/icons/user';
import { SIGNUP_PATHS } from 'constants/constants';
import { useHistory } from 'react-router';

export default function PersonSelectStep() {
  const history = useHistory();
  const [selectedPerson, setSelectedPerson] = useState<
    'Individual' | 'Entity'
  >();

  const onCancel = useCallback(() => {
    history.replace(SIGNUP_PATHS.BASE);
  }, []);

  const onConfirm = useCallback(() => {
    if (selectedPerson === 'Individual') {
      history.push(SIGNUP_PATHS.INDIVIDUAL_INFO);
    } else {
      history.push(SIGNUP_PATHS.INFO);
    }
  }, [selectedPerson]);

  return (
    <div className="person-select-step">
      <p className="p p_font-size_32 mb_24 p_weight_300">Регистрация</p>
      <p className="p mb_24">Укажите, каким лицом вы являетесь</p>
      <div className="mb_32">
        <UiSelect
          placeholder="Выберите тип лица"
          options={[
            {
              label: 'Физическое лицо',
              value: 'Individual',
            },
            {
              label: 'Юридическое лицо',
              value: 'Entity',
            },
          ]}
          onChange={(selected) => {
            if (selected) {
              setSelectedPerson((selected as OptionType).value);
            }
          }}
        />
      </div>
      <div className="flex align-center">
        <IconBtn
          title="Продолжить"
          icon={<UserIcon width={20} height={20} color="#fff" />}
          onClick={onConfirm}
        />
        <button className="button button_primary ml_24" onClick={onCancel}>
          Назад
        </button>
      </div>
    </div>
  );
}
